import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { GoogleTagManager } from './components/GoogleTagManager';
import { StickyNav } from './components/StickyNav';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { StatsSection } from './components/StatsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { StepsSection } from './components/StepsSection';
import { BottomFormSection } from './components/BottomFormSection';
import { ThankYou } from './pages/ThankYou';
function LandingPage() {
  return <div className="min-h-screen flex flex-col font-sans text-gray-800 selection:bg-orange selection:text-white" data-id="element-0">
      <StickyNav data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <StatsSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <StepsSection data-id="element-8" />
        <BottomFormSection data-id="element-9" />
      </main>
    </div>;
}
function DocumentTitle() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/thank-you') {
      document.title = 'Thank You — Keena PEO';
    } else {
      document.title = 'Keena PEO — Simplify HR, Payroll & Compliance';
    }
  }, [location.pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <GoogleTagManager data-id="element-11" />
      <DocumentTitle data-id="element-12" />
      <Routes data-id="element-13">
        <Route path="/" element={<LandingPage data-id="element-15" />} data-id="element-14" />
        <Route path="/thank-you" element={<ThankYou data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}